import React, { PureComponent } from 'react'
import EntityMastersPage from '../../containers/masters/Entity/EntityMastersPage'
import ExtraSaleMastersPage from '../../containers/masters/ExtraSale/ExtraSaleMastersPage'
import PresentsMastersPage from '../../containers/masters/Presents/PresentsMastersPage'
import SuppliedMastersPage from '../../containers/masters/Supplied/SuppliedMastersPage'
import ProcessingAgency from '../../containers/masters/ProcessingAgency/ProcessingAgencyMasterPage'
import ProcessingAgencyAssignationPage from '../../containers/masters/ProcessingAgencyAssignation/ProcessingAgencyAssignationMasterPage'
import PaymentMethodPage from '../../containers/masters/PaymentMethod/PaymentMethodMasterPage'
import Financing from '../../containers/masters/Financing/FinancingMasterPage'
import AssociatedCostsMastersPage from '../../containers/masters/AssociatedCosts/AssociatedCostsMastersPage'
import FuelPage from '../../containers/masters/fuel/FuelMasterPage'
import FaqMastersPage from '../../containers/masters/Faq/FaqMasterPage'
import FaqSectionMastersPage from '../../containers/masters/FaqSection/FaqSectionMasterPage'
import PurchasePresentTypeMastersPage from '../../containers/masters/PurchasePresentType/PurchasePresentTypeMasterPage'
import CampaignMasterPage from '../../containers/masters/Campaign/CampaignMasterPage'
import CampaignGroupMasterPage from '../../containers/masters/CampaignGroup/CampaignGroupMasterPage'
import CampaignTypeMasterPage from '../../containers/masters/CampaignType/CampaignTypeMasterPage'
import StyleTaskMasterPage from '../../containers/masters/StyleTask/StyleTaskMasterPage'
import { permissions } from '../../constants/backendIds'
import { getSectionPermissions } from '../../util/permisionFunctions'
import { sectionPermissions } from '../../constants/dossier/common/buttonsHeader'
import { mastersTabIndex } from '../../constants/components/mastersTabIndex'
import FinancingTypeProductPage from '../../containers/masters/FinancingTypeProduct/FinancingTypeProductMastersPage'
import OuMastersPage from '../../containers/masters/OuLoad/OuMastersPage'
import PwkTypesMasterPage from '../../containers/masters/PaperworkType/PwkTypesMasterPage'
import OperationTypeMasterPage from '../../containers/masters/OperationType/OperationTypeMasterPage'
import DocumentTypeMasterPage from '../../containers/masters/DocumentType/DocumentTypeMasterPage'
import DocumentVisualizationMasterPage from '../../containers/masters/DocumentVisualization/DocumentVisualizationMasterPage'
import DocumentTypeUseMasterPage from '../../containers/masters/DocumentTypeUse/DocumentTypeUseMasterPage'
import OrganizedUnitSaleOperationMasterPage from '../../containers/masters/OrganizedUnitSaleOperation/OrganizedUnitSaleOperationMasterPage'
import MetadataMasterPage from '../../containers/masters/Metadata/MetadataMasterPage'
import DirectionUOMasterPage from '../../containers/masters/DirectionUO/DirectionUOMasterPage'
import LegalCompanyMasterPage from '../../containers/masters/LegalCompany/LegalCompanyMasterPage'
import OrganizedUnitConfigurationMasterPage from '../../containers/masters/OrganizedUnitConfiguration/OrganizedUnitConfigurationMasterPage'
import SaleTypeMastersPage from '../../containers/masters/saleType/SaleTypeMastersPage'
import SignTypeMastersPage from '../../containers/masters/signType/SignTypeMastersPage'
import SignatureConfigMasterPage from '../../containers/masters/SignatureConfig/SignatureConfigMasterPage'
import DossierStageMasterPage from '../../containers/masters/DossierStage/DossierStageMasterPage'
import ProcessingAgencyOrganizedUnitConfigMasterPage from '../../containers/masters/ProcessingAgencyOrganizedUnitConfig/ProcessingAgencyOrganizedUnitConfigMasterPage'
import ImportVehicleModelsPage from '../../containers/masters/ImportVehicleModels/ImportVehicleModelsPage'
import RatingMasterPage from '../../containers/masters/Rating/RatingMasterPage'
import RepairshopMasterPage from '../../containers/masters/Repairshop/RepairshopMasterPage'
import MaritalStatusMasterPage from '../../containers/masters/MaritalStatus/MaritalStatusMasterPage'
import CustomFieldMasterPage from '../../containers/masters/CustomField/CustomFieldMasterPage'
import DestinationCraneMasterPage from '../../containers/masters/DestinationCrane/DestinationCraneMasterPage'
import ProcessingManagerMasterPage from '../../containers/masters/ProcessingManager/ProcessingManagerMasterPage'
import CodeCommissionMastersPage from '../../containers/masters/CodeCommission/CodeCommissionMastersPage'
import MapSections from '../../util/map-sections_v2'
import MapSectionsMasters from '../../util/map-sections-masters'
import MapSectionsMastersGroups from '../../util/map-sections-master-groups'
import SimpleInputText from '../commons/simpleForm/SimpleInputText'
import UserAdminPage from '../../containers/masters/user/UserAdminPage'
import RoleAdminPage from '../../containers/masters/role/RoleAdminPage'
import RecurrentEntityAdminPage from '../../containers/masters/recurrentEntity/RecurrentEntityAdminPage'
import TemplatesPage from '../../containers/masters/templates/TemplatesPage'
import ConditionsMaintenancePage from '../../containers/masters/conditionsMaintenance/ConditionsMaintenancePage'

class Masters extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      secMapMasters: MapSectionsMasters,
      secMapGroups: MapSectionsMastersGroups,
      sectionFilter: '',
      activeTab: mastersTabIndex.suppliedMastersPage,
      sectionTabsConfiguration: {
        suppliedMasters: {
          permission: null
        },
        presentsMasters: {
          permission: null
        },
        extraSaleMasters: {
          permission: null
        },
        entityMasters: {
          permission: null
        },
        processingAgency: {
          permission: null
        },
        financingMasters: {
          permission: null
        },
        associatedCostsMasters: {
          permission: null
        },
        fuel: {
          permission: null
        },
        paymentMethod: {
          permission: null
        },
        financingTypeMasters: {
          permission: null
        },
        faqMasters: {
          permission: null
        },
        faqSectionMasters: {
          permission: null
        },
        processingAgencyAssignation: {
          permission: null
        },
        purchasePresentTypeMasters: {
          permission: null
        },
        campaignMaster: {
          permission: null
        },
        campaignGroupMaster: {
          permission: null
        },
        campaignTypeMaster: {
          permission: null
        },
        styleTasksMaster: {
          permission: null
        },
        financingTypeProduct: {
          permission: null
        },
        organizedUnitMasterUpload: {
          permission: null
        },
        pwkTypeMaster: {
          permission: null
        },
        operationTypeMaster: {
          permission: null
        },
        documentTypeMaster: {
          permission: null
        },
        documentTypeUseMaster: {
          permission: null
        },
        organizedUnitSaleOperationMaster: {
          permission: null
        },
        documentTypeMetadataMaster: {
          permission: null
        },
        documentVisualizationMaster: {
          permission: null
        },
        directionUOMaster: {
          permission: null
        },
        legalCompany: {
          permission: null
        },
        organizedUnitConfigurationMaster: {
          permission: null
        },
        signatureConfigurationMaster: {
          permission: null
        },
        dossierStageMaster: {
          permission: null
        },
        processingAgencyOrganizedUnitConfigMaster: {
          permission: null
        },
        organizedUnitMaster: {
          permission: null
        },
        importVehicleModelMaster: {
          permission: null
        },
        ratingMaster: {
          permission: null
        },
        repairshopMaster: {
          permission: null
        },
        maritalStatusMaster: {
          permission: null
        },
        customFieldsMaster: {
          permission: null
        },
        destinationCraneMaster: {
          permission: null
        },
        processingManagerMaster: {
          permission: null
        },
        signatureTypeMaster: {
          permission: null
        },
        codeCommissionMaster: {
          permission: null
        },
        saleTypeMasters: {
          permission: null
        }
      }

    }
  }

  componentDidUpdate () {
    if (this.props.changeTabFromMaster === true) {
      this.setState({ activeTab: mastersTabIndex.organizedUnitConfiguration })
      this.props.actions.setChangeTabFromConfMaster(this.props.ouIdFromMaster, false)
    }
  }

  componentDidMount () {
    this.initializePermisions(this.props)
  }

  initializePermisions (props) {
    const section = props.sections.filter((tabConf) => tabConf.code === sectionPermissions.masters)
    if (section.length > 0 && section[0] != null) {
      const newState = getSectionPermissions(section[0])
      let permissionState = this.state.sectionTabsConfiguration
      permissionState = { ...permissionState, ...newState }
      this.setState({ sectionTabsConfiguration: permissionState })
      let visibleSectionConfiguration = []
      this.state.secMapMasters.forEach(function (item) {
        var permissionCode = newState[item.code]
        if (permissionCode !== undefined && permissionCode.permission !== null && permissionCode.permission > permissions.hidden) {
          item.active = false
          visibleSectionConfiguration.push(item)
        }
      })
      // visibleSectionConfiguration[0].active = true
      this.setState({ secMapMasters: visibleSectionConfiguration })
    }
  }

  toogleInnerMenu () {
    this.setState({ hideMenu: !this.state.hideMenu })
  }

  filterSections (t) {
    let nameFilter = this.state.sectionFilter

    let secMapMasters = this.props.secMapMasters ?? this.state.secMapMasters

    if (!this.state.sectionFilter) {
      return secMapMasters
    }
    let filtered = secMapMasters.filter(function (item) {
      return t(item.title).toUpperCase().includes(nameFilter.toUpperCase())
    })

    return filtered
  }

  selectSection (code) {
    let visibleSectionConfiguration = []
    this.state.secMapMasters.forEach(element => {
      element.active = element.code === code
      visibleSectionConfiguration.push(element)
    })

    this.props.actions.masterSectionChangeSuccess(visibleSectionConfiguration)
  }

  render () {
    const { t } = this.props
    const secMap = MapSections.masters
    const availableSections = this.filterSections(t)
    const availableGroups = this.state.secMapGroups.filter(group => {
      return availableSections.some(section => section.group === group.name)
    })
    const selectedSection = availableSections.filter(x => x.active === true)[0]
    return (
      <div className="wrapper _nf">
        <div className='wrapper-header'>
          <div className="title-page">
            <i className={secMap.icon + ' icon-page'} />
            <h2>{t(`${secMap.title}`)}</h2>
          </div>
        </div>
        <div className='wrapper-body'>
          <div className={this.state.hideMenu ? 'inner-menu-content innerMenuHide' : 'inner-menu-content'}>
            <div className='inner-menu-helpers'>
              <SimpleInputText
                componentClass = 'searchBox'
                colWidth={100}
                placeholder = {t('SECTIONS.FILTER')}
                value={this.state.sectionFilter}
                onInputChange={sectionFilter => this.setState({ sectionFilter })}
              />
            </div>
            <ul className='availableSectionsList'>
              {availableGroups.map((group, idx) => {
                return (
                  <li key={idx} className='group-title'><span>{t(`${group.title}`)}</span>
                    <ul className='inner-items'>
                      {availableSections.filter(section => section.group === group.name).sort(function (a, b) {
                        return (t(`${a.title}`) > t(`${b.title}`) ? 1 : -1)
                      }).map((item, idx) => {
                        return (
                          <li key={idx} className={ item.active === true ? 'active' : ''}><p onClick={() => this.selectSection(item.code)}>{t(`${item.title}`)}</p></li>
                        )
                      })
                      }
                    </ul>

                  </li>
                )
              })}

            </ul>
          </div>

          <div className='inner-data-content masters'>
            {selectedSection !== undefined && selectedSection.page === 'suppliedMastersPage' &&
              <SuppliedMastersPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'presentsMastersPage' &&
              <PresentsMastersPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'extraSaleMastersPage' &&
              <ExtraSaleMastersPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'entityMastersPage' &&
              <EntityMastersPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'processingAgency' &&
              <ProcessingAgency
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'financingMasters' &&
              <Financing
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'associatedCostsMastersPage' &&
              <AssociatedCostsMastersPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}/>
            }
            {selectedSection !== undefined && selectedSection.page === 'fuelPage' &&
              <FuelPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'paymentMethod' &&
              <PaymentMethodPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'faqMastersPage' &&
              <FaqMastersPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'faqSectionMastersPage' &&
              <FaqSectionMastersPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'processingAgencyAssignationPage' &&
              <ProcessingAgencyAssignationPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'purchasePresentTypeMastersPage' &&
              <PurchasePresentTypeMastersPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'campaignMasterPage' &&
              <CampaignMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'campaignGroupMasterPage' &&
              <CampaignGroupMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'campaignTypeMasterPage' &&
              <CampaignTypeMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'styleTasksMasterPage' &&
              <StyleTaskMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'financingTypeProductPage' &&
              <FinancingTypeProductPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'organizedUnitMasterUploadPage' &&
              <OuMastersPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
                selectSection={(code) => this.selectSection(code)}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'documentVisualizationMasterPage' &&
              <DocumentVisualizationMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'documentTypeUseMasterPage' &&
              <DocumentTypeUseMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'organizedUnitSaleOperationMasterPage' &&
              <OrganizedUnitSaleOperationMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'documentTypeMasterPage' &&
              <DocumentTypeMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'documentTypeMetadataMasterPage' &&
              <MetadataMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'operationTypeMasterPage' &&
              <OperationTypeMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'directionUOMasterPage' &&
              <DirectionUOMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'legalCompanyMasterPage' &&
              <LegalCompanyMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'organizedUnitConfigurationPage' &&
              <OrganizedUnitConfigurationMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'pwkTypesMasterPage' &&
              <PwkTypesMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'saleTypeMastersPage' &&
              <SaleTypeMastersPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'signatureTypeMasterPage' &&
              <SignTypeMastersPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'signatureConfigurationMasterPage' &&
              <SignatureConfigMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'dossierStageMasterPage' &&
              <DossierStageMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'processingAgencyOrganizedUnitConfigMasterPage' &&
              <ProcessingAgencyOrganizedUnitConfigMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'importVehicleModels' &&
              <ImportVehicleModelsPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'ratingMasterPage' &&
              <RatingMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'repairshopMasterPage' &&
              <RepairshopMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'maritalStatusMasterPage' &&
              <MaritalStatusMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'customFieldsMasterPage' &&
              <CustomFieldMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'destinationCraneMasterPage' &&
              <DestinationCraneMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'processingManagerMasterPage' &&
              <ProcessingManagerMasterPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'codeCommissionMasterPage' &&
              <CodeCommissionMastersPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'adminUsersPage' &&
              <UserAdminPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'adminRolesPage' &&
              <RoleAdminPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'adminRecurrentEntitiesPage' &&
              <RecurrentEntityAdminPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'templatesPage' &&
              <TemplatesPage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }
            {selectedSection !== undefined && selectedSection.page === 'conditionsMaintenancePage' &&
              <ConditionsMaintenancePage
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />
            }

            {selectedSection === undefined &&
              <p className="no_results masters" >{t('MASTERS.NO_SECTION_SELECTED')}</p>
            }

          </div>
        </div>
      </div>
    )
  }
}

export default Masters
